import React from 'react';

import Heading from './heading/Heading';
import FileManagerToolbar from './FileManagerToolbar';
import FirmDocumentsHeader from './firmDocuments/FirmDocumentsHeader';
import GlobalFileManagerFilter from './filters/GlobalFileManagerFilter';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function FileManagerHeader() {
  const {
    modals,
    isFirmDocuments,
    setSelectedItem,
    isCaseFileManager,
    isLeadFileManager,
    fileManagerFilters,
    isGlobalFileManager,
    isClientFileManager,
    setVersionFileUpload,
    setFileManagerFilters,
    breadCrumbs,
  } = useFileManagerContext();

  return (
    <>
      {/* Global File Manager Heading */}
      {isGlobalFileManager && !isFirmDocuments && <Heading />}

      {isFirmDocuments && (
        <FirmDocumentsHeader
          modals={modals}
          setSelectedItem={setSelectedItem}
          setVersionFileUpload={setVersionFileUpload}
          breadCrumbs={breadCrumbs}
        />
      )}

      {!isFirmDocuments && !isCaseFileManager && !isClientFileManager && !isLeadFileManager && (
        <GlobalFileManagerFilter setFileManagerFilters={setFileManagerFilters} fileManagerFilters={fileManagerFilters} />
      )}

      {/* Case, Client and Lead File Manager Filters */}
      {(isCaseFileManager || isClientFileManager || isLeadFileManager) && <FileManagerToolbar />}
    </>
  );
}

export default FileManagerHeader;
